var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Controller } from "@hotwired/stimulus";
export default class sortable_paragraphs_controller_default extends Controller {
  connect() {
    this.draggingCard = null;
    this.boundDragOver = this.onDragOver.bind(this);
    this.boundDrop = this.onDrop.bind(this);
    this.element.addEventListener("dragover", this.boundDragOver);
    this.element.addEventListener("drop", this.boundDrop);
  }
  disconnect() {
    this.element.removeEventListener("dragover", this.boundDragOver);
    this.element.removeEventListener("drop", this.boundDrop);
  }
  start(event) {
    const card = event.target.closest(".pt-paragraph");
    if (!card) return;
    this.draggingCard = card;
    card.classList.add("pt-paragraph--dragging");
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", card.dataset.paragraphId || "");
    const rect = card.getBoundingClientRect();
    event.dataTransfer.setDragImage(card, event.clientX - rect.left, event.clientY - rect.top);
  }
  end() {
    if (this.draggingCard) this.draggingCard.classList.remove("pt-paragraph--dragging");
    this.clearIndicators();
    this.draggingCard = null;
  }
  onDragOver(event) {
    if (!this.draggingCard) return;
    const target = event.target.closest(".pt-paragraph");
    if (!target || target === this.draggingCard) {
      this.clearIndicators();
      return;
    }
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    const placeAbove = this.isAbove(event, target);
    this.clearIndicators();
    target.classList.add(placeAbove ? "pt-paragraph--drop-above" : "pt-paragraph--drop-below");
  }
  onDrop(event) {
    if (!this.draggingCard) return;
    event.preventDefault();
    const target = event.target.closest(".pt-paragraph");
    if (!target || target === this.draggingCard) {
      this.end();
      return;
    }
    const cardsBefore = Array.from(this.element.querySelectorAll(".pt-paragraph"));
    const oldIndex = cardsBefore.indexOf(this.draggingCard);
    const placeAbove = this.isAbove(event, target);
    if (placeAbove) {
      target.parentNode.insertBefore(this.draggingCard, target);
    } else {
      target.parentNode.insertBefore(this.draggingCard, target.nextSibling);
    }
    const cardsAfter = Array.from(this.element.querySelectorAll(".pt-paragraph"));
    const newIndex = cardsAfter.indexOf(this.draggingCard);
    const moveUrl = this.draggingCard.dataset.moveUrl;
    this.end();
    if (newIndex === oldIndex || !moveUrl) return;
    const newPosition = this.pageOffsetValue + newIndex;
    this.sendMove(moveUrl, newPosition);
  }
  isAbove(event, card) {
    const rect = card.getBoundingClientRect();
    return event.clientY < rect.top + rect.height / 2;
  }
  clearIndicators() {
    this.element.querySelectorAll(".pt-paragraph--drop-above, .pt-paragraph--drop-below").forEach((el) => {
      el.classList.remove("pt-paragraph--drop-above", "pt-paragraph--drop-below");
    });
  }
  sendMove(moveUrl, newPosition) {
    var _a;
    const csrf = ((_a = document.querySelector('meta[name="csrf-token"]')) == null ? void 0 : _a.content) || "";
    const formData = new FormData();
    formData.append("position_to_move_to", newPosition);
    formData.append("authenticity_token", csrf);
    fetch(moveUrl, {
      method: "POST",
      headers: { Accept: "text/vnd.turbo-stream.html, text/html" },
      body: formData
    }).then((response) => response.text()).then((html) => {
      if (window.Turbo && typeof window.Turbo.renderStreamMessage === "function") {
        window.Turbo.renderStreamMessage(html);
      }
    }).catch((err) => {
      console.error("Move failed:", err);
    });
  }
}
__publicField(sortable_paragraphs_controller_default, "values", {
  pageOffset: { type: Number, default: 0 }
});
